<template lang='pug'>
wizard(
  ref="wizard"
  :nextStep='nextStep',
  :prevButtonText='"Voltar"',
  :nextButtonText='currentTab === "edit" ? "Finalizar" : "Próximo"',
  :finishButtonText='"OK"',
  :startIndex.sync='activeTabIndex'
  @length='tabsLength = $event'
  @finished-import='wizardComplete'
  @tab-change='handleTabChange')
  template(slot='header')
    v-row(style='justify-content: space-between')
      v-col(cols='auto')
        span(
          style='font-size: 1.125rem; line-height: 1.4em; font-weight: 300; font-size: 18px;') {{$t('importWizard.importWorkspace')}}
      v-col(cols='auto')
        md-button.md-simple.md-github.md-just-icon(
          @click='$emit("close-dialog")')
          md-icon close
  slot
</template>

<script>
import Wizard from '@/components/Wizard/Wizard'

export default {
  name: 'ImportWizard',
  props: ['importType', 'nextStep', 'currentTab'],
  components: {
    Wizard
  },
  data () {
    return {
      activeTabIndex: 0,
      tabsLength: 0,
      loading: true
    }
  },
  methods: {
    wizardComplete () {
      this.$emit('close-dialog')
    },
    disableTabsAfterIndex (index) {
      this.$refs.wizard.disableTabsAfterIndex(index)
    },
    disableTabsBefore () {
      this.$refs.wizard.disableTabsBefore()
    },
    handleTabChange (oldTab, newTab) {
      this.$emit('update:currentTab', newTab.id)
    }
  }
}
</script>
